var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_9958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64863 18.1293L5.60438 22.0277L1.78764 22.1084C0.646992 19.9928 0 17.5722 0 14.9999C0 12.5126 0.604922 10.1669 1.67719 8.10156H1.67801L5.07598 8.72453L6.56449 12.1021C6.25295 13.0104 6.08314 13.9854 6.08314 14.9999C6.08326 16.101 6.28271 17.156 6.64863 18.1293Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.738 12.1973C29.9102 13.1046 30.0001 14.0417 30.0001 14.9995C30.0001 16.0734 29.8872 17.1209 29.6721 18.1313C28.9419 21.5698 27.0339 24.5723 24.3908 26.697L24.39 26.6962L20.11 26.4778L19.5043 22.6964C21.2581 21.6679 22.6287 20.0583 23.3507 18.1313H15.3298V12.1973H29.738Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3898 26.6962L24.3906 26.697C21.82 28.7632 18.5546 29.9995 15 29.9995C9.2876 29.9995 4.32113 26.8066 1.7876 22.108L6.64859 18.1289C7.91533 21.5096 11.1766 23.9163 15 23.9163C16.6433 23.9163 18.1829 23.472 19.5041 22.6965L24.3898 26.6962Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5745 3.45328L19.7152 7.43156C18.3479 6.57691 16.7316 6.0832 15.0001 6.0832C11.0902 6.0832 7.76789 8.60021 6.56461 12.1022L1.67807 8.10164H1.67725C4.17369 3.28846 9.20279 0 15.0001 0C18.6396 0 21.9767 1.29645 24.5745 3.45328Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_9958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.638d6a1db4e4169921b1c23174ce87b0.svg";
export { ForwardRef as ReactComponent };